var isFunction = require('../lang/isFunction');

    function result(obj, prop) {
        var property = obj[prop];

        if(property === undefined) {
            return;
        }

        return isFunction(property) ? property.call(obj) : property;
    }

    module.exports = result;




//////////////////
// WEBPACK FOOTER
// ./~/mout/object/result.js
// module id = 1646
// module chunks = 0 1 2